// extracted by mini-css-extract-plugin
module.exports = {"tableWrapperWithFooter":"TableWrapperWithFooter_tableWrapperWithFooter__3ki08"};